import { render } from "./WhySogdo.vue?vue&type=template&id=2a1175f3&scoped=true"
import script from "./WhySogdo.vue?vue&type=script&lang=js"
export * from "./WhySogdo.vue?vue&type=script&lang=js"

import "./WhySogdo.vue?vue&type=style&index=0&id=2a1175f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1175f3"]])

export default __exports__